import React from "react";


const ContactUs = () => {

    

    return (
        <div className="">
            <h1>Hello ContactUs</h1>
        </div>
    );
};

export default ContactUs;